import React, { Fragment, useEffect, useState } from 'react';
import Breadcrumb from '../common/breadcrumb';
import { useNavigate } from 'react-router-dom';
import { RECRUITMENTAPI } from '../../api/axios';
import { toast } from 'react-toastify';
import { Check, Eye, Trash, X } from 'react-feather';
import { CONTACTAPI } from '../../api/contact';
import OrderedTrainingDetails from './components/OrderedTrainingDetails';
import SweetAlert from 'sweetalert2';
import { Spinner, Table } from 'reactstrap';

import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';



const TrainingSubscriptions = () => {
    const navigate = useNavigate();
    const clickApply = (job) => {
        navigate(`${process.env.PUBLIC_URL}/jobSearch/job-detail/${job.id}`);
    }

    const [isOpen, setIsOpen] = useState(false);
    const [subscriptions, setSubscriptions] = useState([]);
    const [toDelete, setToDelete] = useState([]);
    const [subscription, setSubscription] = useState(undefined);
    const [isLoading, setIsLoading] = useState(true);

    const handleDeleteSubscription = (event, subsc) => {
        event.preventDefault();
        
        SweetAlert.fire({
            title: 'Are you sure?',
            text: "Once deleted, you will not be able to recover this Training subscription!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ok',
            cancelButtonText: 'cancel',
            reverseButtons: true
        }).then((result) => {
            if (result.value) {
                // setIsDeleting(subsc.id);
                setToDelete(subsc.id);
                CONTACTAPI.delete(`training${subsc.id}/`).then((resp) => {
                
                    setTimeout(() => {
                        toast.success("La souscription a bien ete supprimee");
                    }, 200);
                    const newArr = toDelete.filter(item => item != subsc.id);
                    setToDelete(newArr);
                    
                    // Remove deleted idtem from array

                    const newSubscriptionsArray = subscriptions.filter(item => item.id != subsc.id);
                    setSubscriptions(newSubscriptionsArray);
                    // navigate(`${process.env.PUBLIC_URL}/jobSearch/jobs`);
                    SweetAlert.fire(
                    'Deleted!',
                    'The Subscription has been deleted.',
                    'success'
                    )
                }).catch(err => {
                    setTimeout(() => {
                        toast.error("Oppss.. Une erreur s'est produite. Veuiller reessayer");
                    }, 200);
                    // setIsDeleting(false);
                })
            }
            else {
                SweetAlert.fire(
                'Your Subscription is safe!'
                )
            }
        })
    }

    const handleModalClose = () => {
        setIsOpen(!isOpen)
    }

    const handleShowDetails = (event, contact) => {
        event.preventDefault();
        setIsOpen(true);
        setSubscription(contact);
    }

    useEffect(() => {
        // CONTACTAPI.get(`trainings/`).then(res => setJobData(res.data.results))

        CONTACTAPI.get("training").then((resp) => {
            // console.log(resp)
            // fetch job applications 
            
            let results = resp.data.results;
            
            setSubscriptions(results);
            setIsLoading(false);
        }).catch(err => {
            setTimeout(() => {
                toast.error("Oppss.. Une erreur s'est produite. Veuiller reessayer");
            }, 200);
            setIsLoading(false);
        });
    }, [])

    return (
        <Fragment>
            <Breadcrumb title="Subscriptions" parent="Trainings" />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12 xl-60">
                        <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>{"Subscriptions list"}</h5>
                                </div>
                                <div className="card-block row">
                                    <div className="col-sm-12 col-lg-12 col-xl-12">
                                        <div className="table-responsive"> 
                                            {
                                                isLoading && <Box sx={{ width: '100%', marginBottom: '1rem' }}>
                                                    <LinearProgress />
                                                </Box>
                                            }
                                            <table className="table table-hover">
                                                <caption>{"List of subscriptions"}</caption>
                                                <thead>
                                                    <tr>
                                                        <th scope="col">{"#"}</th>
                                                        <th scope="col">{"First Name"}</th>
                                                        <th scope="col">{"Last Name"}</th>
                                                        <th scope="col">{"Email"}</th>
                                                        <th scope="col">{"Phone"}</th>
                                                        <th scope="col">{"Postal code"}</th>
                                                        <th scope="col">{"Training"}</th>
                                                        <th scope="col">{"Society"}</th>
                                                        <th scope="col">{"Role"}</th>
                                                        <th scope="col">{"Number of inscriptions"}</th>
                                                        <th scope="col">{"Interested by the course"}</th>
                                                        <th scope="col">{"Other informations"}</th>
                                                        <th scope="col">{"Actions"}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        !isLoading && subscriptions.length===0 && <p className="text-center">{"Any data"}</p>
                                                    }
                                                    {
                                                        !isLoading && subscriptions.map((subscription, index) => {

                                                            return(
                                                                <tr key={`application-${subscription.id}`}>
                                                                    <th scope="row">{index + 1}</th>
                                                                    <td>
                                                                        <p className="text-1-line">
                                                                            {subscription.first_name}
                                                                        </p>
                                                                    </td>
                                                                    <td>
                                                                        <p className="text-1-line">
                                                                            {subscription.last_name}
                                                                        </p>
                                                                    </td>
                                                                    <td>
                                                                        <p className="text-1-line">
                                                                            {subscription.email}
                                                                        </p>
                                                                    </td>
                                                                    <td>
                                                                        <p className="text-1-line">
                                                                            {subscription.phone}
                                                                        </p>
                                                                    </td>
                                                                    <td>
                                                                        <p className="text-1-line">
                                                                            {subscription.postal_code}
                                                                        </p>
                                                                    </td>
                                                                    <td>
                                                                        <p className="text-1-line">
                                                                        {subscription.training}
                                                                        </p>
                                                                    </td>
                                                                    <td>
                                                                        <p className="text-1-line">
                                                                        {subscription.society}
                                                                        </p>
                                                                    </td>
                                                                    <td>
                                                                        <p className="text-1-line">
                                                                        {subscription.role}
                                                                        </p>
                                                                    </td>
                                                                    <td>
                                                                        <p className="text-1-line">
                                                                        {subscription.number_of_inscriptions}
                                                                        </p>
                                                                    </td>
                                                                    <td>
                                                                        <p className="text-1-line">
                                                                        {subscription?.interested_by_the_course ? <Check size={15} style={{color: 'green'}}/> : <X size={15} style={{color: 'red'}}/> }
                                                                        </p>
                                                                    </td>
                                                                    <td>
                                                                        <p className="text-1-line">
                                                                        {subscription.oher_informations}
                                                                        </p>
                                                                    </td>
                                                                    <td>
                                                                        
                                                                        <a href='#' onClick={(event) => handleShowDetails(event, subscription)}><Eye/> </a>
                                                                        { !toDelete.includes(subscription.id) ? <a href={`#`} onClick={(event) => handleDeleteSubscription(event, subscription)}><Trash color='red'/></a> :
                                                                        <Spinner style={{color: 'red'}} size={10}/>}
                                                                        {/* <a href={`${process.env.PUBLIC_URL}/contact/messages/details/${subscription.id}`}><Eye/></a> *
                                                                        {* <a href='#'><i data-feather="eye"></i></a>
                                                                        <a href='#'><i data-feather="eye"></i></a> */}
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            <OrderedTrainingDetails isOpen={isOpen} modalToggle={handleModalClose} subscription={subscription} />
            </div>
        </Fragment>
    );
};

export default TrainingSubscriptions;